import { AuthConfig, AuthProvider } from '@conteg/auth';
import * as Sentry from '@sentry/react';
import { AUTH_CLIENT_ID } from 'config';
import env from 'env/env';
import { ReactNode } from 'react';

export const AuthContextProvider = ({ children }: { children: ReactNode }) => {
  const authConfig: AuthConfig = {
    scope: 'Api.access IntegrationApi.read IntegrationApi.write',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    subjectId: env.VITE_AUTH_SUBJECT_ID || '',
    applicationInstanceId: env.VITE_AUTH_APP_INSTANCE_ID || '',
    authority: env.VITE_IDENTITY_API_URL || '',
    clientId: AUTH_CLIENT_ID,
    issuer: 'Conteg_X2d',
    endSessionEndpoint: `${env.VITE_IDENTITY_WEB_URL}/logout`,
    onSignIn(user) {
      if (user) {
        Sentry.setUser({ id: user.profile.sub, email: user.profile.email });
      }
    },
    onRemoveUser() {
      Sentry.setUser(null);
    },
  };

  return <AuthProvider config={authConfig}>{children}</AuthProvider>;
};
